export default __webpack_public_path__ + "static/media/120.9d0574fc.jpg";